import { FullPageCard, GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";

export function MatterNotFound() {
  const { hasPagePermission } = useUser();

  // If the user doesn't have permission to view matters, we don't want to
  // give them information about whether a matter exists or not.
  if (!hasPagePermission(PAGE_PERMISSION_KEYS.mattersDetail)) {
    return <GlobalNotAuthorized />;
  }

  return (
    <FullPageCard
      backButtonLink="/matters"
      backButtonTitle="Back to matters"
      title="Matter not found"
    >
      <p className="text-muted-foreground">
        {`Oops! The Matter you're looking for doesn't exist.`}
      </p>
    </FullPageCard>
  );
}
